module.exports = __webpack_public_path__ + "static/media/0fbdf6f9.jpg";